export default "__VITE_ASSET__Do7OTTUH__"